import { useSelector } from "react-redux";
import styled from "styled-components";
import { ButtonT1 } from "../../../../components/atoms/Button/Button";
import { authUser } from "../../../../store/slice/authSlice";
import { BannerCloseButton, useBannerDismiss } from "./DismissibleBanner";

const BannerBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 48px;
  background: #eef4ff;
  border-bottom: 1px solid #c5d7f5;
  color: #262641;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
`;

const storeLabel = store => store.store_name || store.shop;

/**
 * Lists active Shopify stores that must reopen Orderlink from Shopify admin so
 * OAuth can run again (disconnected, outdated token, or new permissions).
 */
export const ShopifyScopesBanner = () => {
  const user = useSelector(authUser);
  const stores = Array.isArray(user?.shopify_reauth_stores)
    ? user.shopify_reauth_stores
    : user?.shopify_reauth_url
      ? [{ id: "legacy", reconnect_url: user.shopify_reauth_url, store_name: "Your Shopify store" }]
      : [];

  const [dismissed, dismiss] = useBannerDismiss(
    `shopifyScopesBannerDismissed:${stores.map(store => store.id).join(",")}`
  );

  if (!stores.length || dismissed) return null;

  const message =
    stores.length === 1
      ? `${storeLabel(stores[0])} needs to be reconnected to keep orders and inventory syncing.`
      : `${stores.length} Shopify stores need to be reconnected to keep orders and inventory syncing.`;

  return (
    <BannerBar role="status">
      <span>{message}</span>
      {stores.map(store => (
        <ButtonT1
          key={store.id}
          title={stores.length === 1 ? "Reconnect in Shopify" : `Reconnect ${storeLabel(store)}`}
          onClickCallback={() => {
            window.location.href = store.reconnect_url;
          }}
        />
      ))}
      <BannerCloseButton onClick={dismiss} />
    </BannerBar>
  );
};
